import { Box, Col, Row } from '@opendoor/atoms/box';
import { Button } from '@opendoor/atoms/button';
import { Dialog } from '@opendoor/atoms/dialog';
import { Text } from '@opendoor/atoms/text';
import { IconCalendarClock, IconClockHour4, IconFileCheck, IconTag } from '@tabler/icons-react';

const TITLE = 'Here’s how to buy this home';
const DESCRIPTION = 'What to expect before you start.';

const STEPS = [
  {
    icon: IconClockHour4,
    title: 'About 15 minutes online',
    subtitle: 'Complete the offer right here with no paperwork required.',
  },
  {
    icon: IconTag,
    title: 'Fixed pricing',
    subtitle: 'What you see on the listing is what you pay.',
  },
  {
    icon: IconCalendarClock,
    title: 'Detail confirmation',
    subtitle: 'Your contact information, how you’re paying, and your closing date.',
  },
  {
    icon: IconFileCheck,
    title: 'Review and submit',
    subtitle: 'The seller’s agent will be in contact.',
  },
];

export const BuyDirectContextModal = ({
  isOpen,
  onClose,
  continueHref,
}: {
  isOpen: boolean;
  onClose: () => void;
  continueHref: string;
}) => (
  <Dialog.Root
    role="dialog"
    open={isOpen}
    onOpenChange={(open) => {
      if (!open) {
        onClose();
      }
    }}
  >
    <Dialog>
      {/* Sized to match the PDP address in PropertySummary. */}
      <Dialog.Title className="pb-1 text-subheader-sm text-od-content-primary sm:pb-1 md:text-subheader-lg">
        {TITLE}
      </Dialog.Title>
      <Dialog.Description className="text-body-md text-od-content-secondary">
        {DESCRIPTION}
      </Dialog.Description>
      <Col className="w-full gap-6 pt-6 md:w-110">
        <Col className="w-full">
          {STEPS.map(({ icon: Icon, title, subtitle }, index) => {
            const isLast = index === STEPS.length - 1;
            return (
              <Row key={title} className="w-full items-stretch">
                <Col className="items-center pr-4">
                  <Box className="size-10 shrink-0 items-center justify-center rounded-full border border-od-border-primary bg-od-bg-secondary">
                    <Icon size={20} className="text-od-content-secondary" />
                  </Box>
                  {!isLast && <Box className="w-px flex-1 bg-od-border-primary" />}
                </Col>
                <Col className={`items-start ${isLast ? '' : 'pb-6'}`}>
                  <Text className="text-body-md font-medium text-od-content-primary">{title}</Text>
                  <Text className="text-body-sm text-od-content-tertiary">{subtitle}</Text>
                </Col>
              </Row>
            );
          })}
        </Col>
        <Button
          analyticsName="cosmos-marketplace-buy-direct-context-continue"
          aria-label="Continue"
          href={continueHref}
          variant="primary"
          size="lg"
          className="w-full max-w-80 self-center"
        >
          Continue
        </Button>
      </Col>
    </Dialog>
  </Dialog.Root>
);
